import { render, staticRenderFns } from "./MomentSelectorAndSorterComponent.vue?vue&type=template&id=b0e49798&scoped=true&"
import script from "./MomentSelectorAndSorterComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentSelectorAndSorterComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentSelectorAndSorterComponent.vue?vue&type=style&index=0&id=b0e49798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e49798",
  null
  
)

export default component.exports